import { getIdOrNull, requestMultipart, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

export const createInternshipRequest = (user, internshipRequest) => apiClient.post(user, 'api/individual-internship-requests', internshipRequest)

export const publicCreateInternshipRequest = (internshipRequest) => apiClient.post(null, 'public/individual-internship-requests', internshipRequest)

export const getAllInternshipRequests = (user, parameters = {}) => apiClient.get(user, 'api/individual-internship-requests', parameters)

export const deleteInternshipRequest = (user, internshipRequest) => apiClient.delete(user, `api/individual-internship-requests/${getIdOrNull(internshipRequest)}`)

export const updateInternshipRequest = (user, internshipRequest) => apiClient.patch(user, `api/individual-internship-requests/${getIdOrNull(internshipRequest)}`, internshipRequest)

export const setInternshipRequestToOnHold = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/on-hold`,
    HttpMethods.PATCH,
    {},
    user
  )
}

export const getInternshipRequestFiles = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/files`,
    HttpMethods.GET,
    null,
    user
  )
}

export const deleteInternshipRequestFile = (user, internshipRequest, internshipRequestFile) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/files/${getIdOrNull(internshipRequestFile)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const addInternshipRequestFile = (user, internshipRequest, file) => {
  return requestMultipart(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/files`,
    HttpMethods.POST,
    file,
    user
  )
}

export const publicAddInternshipRequestFile = (internshipRequest, file) => {
  return requestMultipart(
    `/public/individual-internship-requests/${getIdOrNull(internshipRequest)}/files`,
    HttpMethods.POST,
    file,
    null
  )
}

export const createInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/request-periods`,
    HttpMethods.POST,
    requestPeriod,
    user
  )
}

export const deleteInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/request-periods/${getIdOrNull(requestPeriod)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const deleteInternshipRequestPeriods = (user, internshipRequest, parameters = { ids: [] }) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/request-periods${makeQueryString(parameters)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const updateInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/request-periods/${getIdOrNull(requestPeriod)}`,
    HttpMethods.PATCH,
    requestPeriod,
    user
  )
}

export const acceptInternshipRequest = (user, internshipRequest, requestPeriods) => {
  return requestWithPromise(
    '/internship/create-from-request',
    HttpMethods.POST,
    { individualInternshipRequest: getIdOrNull(internshipRequest), requestPeriods: requestPeriods, sector: getIdOrNull(internshipRequest.sector) },
    user
  )
}

export const refuseInternshipRequest = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${getIdOrNull(internshipRequest)}/refuse`,
    HttpMethods.DELETE,
    null,
    user
  )
}
